module.exports = __webpack_public_path__ + "img/sol_cap2.04db2413.png";